const ACTIVE_LINK_CLASS = 'law-reference-active'

// Store active link element outside of useState (DOM refs can't be serialized)
let activeLinkElement: HTMLElement | null = null

export function useLawReferencePanel() {
  const referenceLawId = useState<string | null>('lawReferencePanel', () => null)
  const referenceOrigin = useState<ContainerKey | null>('lawReferenceOrigin', () => null)

  // Clean up stale DOM references when the composable scope is disposed
  onScopeDispose(() => {
    if (activeLinkElement) {
      activeLinkElement.classList.remove(ACTIVE_LINK_CLASS)
      activeLinkElement = null
    }
    referenceLawId.value = null
    referenceOrigin.value = null
  })

  function showReference(lawId: string, origin: ContainerKey, linkElement?: HTMLElement) {
    if (activeLinkElement) {
      activeLinkElement.classList.remove(ACTIVE_LINK_CLASS)
    }

    referenceLawId.value = lawId
    referenceOrigin.value = origin

    if (linkElement) {
      activeLinkElement = linkElement
      activeLinkElement.classList.add(ACTIVE_LINK_CLASS)
    }
  }

  function closeReference() {
    if (activeLinkElement) {
      activeLinkElement.classList.remove(ACTIVE_LINK_CLASS)
      activeLinkElement = null
    }

    referenceLawId.value = null
    referenceOrigin.value = null
  }

  return {
    referenceLawId: readonly(referenceLawId),
    referenceOrigin: readonly(referenceOrigin),
    showReference,
    closeReference,
  }
}
